<script setup lang="ts">
const route = useRoute()

const { data: navigation } = await useAsyncData('navigation', () =>
  fetchContentNavigation(),
)
</script>

<template>
  <nav v-if="navigation?.length" class="flex flex-wrap justify-center gap-6 text-base font-medium text-gray-700 dark:text-gray-300">
    <NuxtLink
      v-for="item in navigation"
      :key="item._path"
      :to="item._path"
      class="hover:text-primary-500 transition-colors"
      :class="route.path === item._path || route.path.startsWith(item._path + '/') ? 'text-primary-500' : ''"
    >
      {{ item.title }}
    </NuxtLink>
  </nav>
</template>
